export default {"src":"/_next/static/media/faq-icon6.b9a791af.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};